<template lang="pug">

	b-link.eventImageLink(v-if="link" :to="link" :class="title?'--overlay':''")
		.eventImageLink__spinnerWrp
			b-spinner(type="grow" label="Loading...")
		b-img-lazy.eventImageLink__img(:src="img||defaultImg")
		div.eventImageLink__body(v-if="title")
			h2.eventImageLink__title {{ title }}

	span.eventImageLink(v-else :class="title?'--overlay':''")
		.eventImageLink__spinnerWrp
			b-spinner(type="grow" label="Loading...")
		b-img-lazy.eventImageLink__img(:src="img||defaultImg")
		div.eventImageLink__body(v-if="title")
			h2.eventImageLink__title {{ title }}

</template>

<script type="text/babel">
	export default {
		name: 'ImgLazyWthPreloader',
		data: () => ({
			defaultImg: '/img/placeholders/event.jpg',
		}),
		props: ['link','img','title'],
		computed: {
			alertShow(){ return !this.loader.show ? 'js-hidden' : '' }
		},
	}
</script>

